export default __webpack_public_path__ + "static/media/user.cc672939.png";